import ar from './ar.json';
import en from './en.json';

/**
 * The Admins module's catalogue, registered from `app.config.tsx` under the
 * `admins` namespace — `shared/i18n` never imports a module (W2).
 */
export const adminsCatalogs = { ar, en };
